var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcTextField',{attrs:{"required":true,"model-value":_vm.flag,"label-outside":true,"placeholder":_vm.t('mail', 'Enter flag')},on:{"update:value":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }